module.exports = __webpack_public_path__ + "assets/img/12_36_big.c6b69ff8.jpg";